<template>
  <div class="npb-pincode-wrapper">
    <div class="npb-pincode-inner-wrapper">
      <label v-if="target" class="npb-pincode-label">
        <span v-if="channelTarget === 'FLASH_CALL' || channelTarget === 'VOICE_CALL'">
          <i18n val="calling_to"></i18n>
        </span>
        <span v-else>
          <i18n val="code_has_been_sent_to"></i18n>
        </span>
        <span class="npb-pincode-target">{{target}}</span>
      </label>
      <label v-else class="npb-pincode-label">
        <i18n val="phone_confirmation_code"></i18n>
      </label>
      <div class="npb-pincode-container">
        <input
            type="tel"
            class="npb-pincode"
            ref="pin1"
            maxlength="1"
            autocomplete="off"
            data-name="pin1"
            v-model.number="pin1"
            @input="onPincodeChange"
            @keydown = "onPincodeChange"
            @focus="onFieldFocused"
            @paste="onPaste">
        <input
            type="tel"
            class="npb-pincode"
            ref="pin2"
            maxlength="1"
            autocomplete="off"
            data-name="pin2"
            v-model.number="pin2"
            @input="onPincodeChange"
            @keydown = "onPincodeChange"
            @focus="onFieldFocused"
            @paste="onPaste">
        <input
            type="tel"
            class="npb-pincode"
            ref="pin3"
            maxlength="1"
            autocomplete="off"
            data-name="pin3"
            v-model.number="pin3"
            @input="onPincodeChange"
            @keydown = "onPincodeChange"
            @focus="onFieldFocused"
            @paste="onPaste">
        <input
            type="tel"
            class="npb-pincode"
            ref="pin4"
            maxlength="1"
            autocomplete="off"
            data-name="pin4"
            v-model.number="pin4"
            @input="onPincodeChange"
            @keydown = "onPincodeChange"
            @focus="onFieldFocused"
            @paste="onPaste">
      </div>
    </div>
    <div class="npb-pincode-resend">
      <div v-if="timerCount">
        <span>{{timerCount}}</span>
      </div>
      <button type="button" v-if="channel && currentChannel && !timerCount" @click.stop="onResendCode">
        <i18n val="resend"></i18n>
      </button>
      <button type="button" v-if="startSend" @click.once="onSendCode">
        <i18n val="send"></i18n>
      </button>
      <button type="button" v-if="supportButton && !channel && !timerCount" @click.stop="showSupportChat">
        <i18n val="support_help"></i18n>
      </button>
    </div>
  </div>
</template>

<script>
    import I18n from "./i18n.vue";

    let currentPosition = 1;
    export default {
      components: {I18n},
      data() {
        return {
          pin1: null,
          pin2: null,
          pin3: null,
          pin4: null,
          timerCount: null,
          startSend: null,
          currentChannel: '',
        }
      },
      props: {
        target: String,
        channel: String,
        channelTarget: String || null,
        resendInterval: Number,
        startTimer: Boolean,
        supportButton: Boolean,
        onResend: Function,
        onSendOnce: Function,
      },
      mounted() {
        this.$nextTick(function () {
          if (this.channel && this.channel.length > 0) {
            this.currentChannel = this.channel;
            this.timerCount = this.resendInterval;
          }
          if (this.onSendOnce) {
            this.startSend = true;
          }
        })
      },
      methods: {
        onSendCode() {
          this.startSend = false;
          this.onSendOnce();
        },
        onResendCode() {
          const response = this.onResend();
          if (response === true) {
            this.requestStartTimer();
          }
        },
        requestStartTimer() {
          this.timerCount = this.resendInterval;
        },
        showSupportChat() {
          window.showMessenger();
        },
        setCurrentPin(pinId, val) {
          switch (pinId) {
            case 'pin1':
              this.pin1 = val;
              break;
            case 'pin2':
              this.pin2 = val;
              break;
            case 'pin3':
              this.pin3 = val;
              break;
            case 'pin4':
              this.pin4 = val;
              break;
            default:
          }
        },
        increasePosition() {
          currentPosition += 1;
          this.$refs[`pin${currentPosition}`].focus();
        },
        decreasePosition() {
          this[`pin${currentPosition}`] = null;
          currentPosition -= 1;
          this.$refs[`pin${currentPosition}`].focus();
        },
        onPaste(event) {
          const regex = /^\d+$/;
          const copyData = event.clipboardData.getData('Text');
          if (copyData.length === 4 && regex.test(parseInt(copyData))) {
            this.pin1 = copyData[0];
            this.pin2 = copyData[1];
            this.pin3 = copyData[2];
            this.pin4 = copyData[3];
          } else {
            this.setCurrentPin('pin'+currentPosition, null)
          }
        },
        onPincodeChange(event) {
          const regex = /^\d+$/;
          if (event.inputType === 'insertFromPaste' || event.inputType === 'deleteContentBackward' && !event.data) {
            return;
          }
          if ((event.inputType === 'deleteContentBackward' && currentPosition > 1) ||
              (event.key === 'Backspace' && currentPosition > 1)
          ) {
            if (!event.target.value.length) {
              event.preventDefault();
              this.decreasePosition();
            }

            return
          }
          if (regex.test(parseInt(event.key)) && event.target.value.length === 1 && currentPosition <= 4) {
            this.setCurrentPin('pin'+currentPosition, event.key);
            if (currentPosition !== 4) {
              this.increasePosition();
            }
            event.preventDefault();
            return;
          }
          if (event.data && !regex.test(event.data)) {
            this.setCurrentPin('pin'+currentPosition, null);
            return;
          }
          if (event.inputType === 'insertText' && event.target.value.length === 1 && currentPosition < 4) {
            this.increasePosition();
          }
        },
        onFieldFocused(event) {
          const number = event.target.dataset.name;
          currentPosition = parseInt(number[number.length-1]);
        },
        pincodeReady() {
          if (this.pin1 !== null && this.pin2 !== null && this.pin3 !== null && this.pin4 !== null) {
            this.$emit('pinready', `${this.pin1}${this.pin2}${this.pin3}${this.pin4}`);
          } else {
            this.$emit('pinready', '');
          }
        }
      },
      watch: {
        timerCount: {
          handler(value) {
            if (value) {
              setTimeout(() => {
                this.timerCount--;
              }, 1000);
            }
            if (value === 0) {
              this.$emit('intervalfinished');
            }
          },
          immediate: true
        },
        startTimer: {
          handler(value) {
            if (value && this.timerCount === 0) {
              this.requestStartTimer();
            }
          }
        },
        pin1: {
          handler() {
            this.pincodeReady()
          }
        },
        pin2: {
          handler() {
            this.pincodeReady()
          }
        },
        pin3: {
          handler() {
            this.pincodeReady()
          }
        },
        pin4: {
          handler() {
            this.pincodeReady()
          }
        },

      }
    }
</script>

<style scoped>
.npb-pincode-target {
    direction: ltr;
    display: inline-block;
}
</style>
